import React from 'react';
import Link from 'next/link';
import Icon from '@components/common/assets';
import ImgSlide from '@components/events/eventChuseok/imgSlide';
import { ModalState } from '../modal';
import Colors from '@domain/constant/colors';
import { RouteUrl } from '@utils/routeUtil';
import classnames from 'classnames/bind';
import styles from './index.module.scss';
const cx = classnames.bind(styles);

interface GiftProps {
  openModal: (modalState: ModalState) => void;
}

const Step = ({ openModal }: GiftProps) => {
  return (
    <div className={cx('commonBox', 'blackTag')}>
      <div className={cx('tagBox')}>
        <span className={cx('num')}>05.</span>
        프로필 입력 방법
      </div>

      {/* 이미지 슬라이드 */}
      <ImgSlide>
        <div className={cx('sliderItem', 'type1')}>
          <Link className={cx('btnBasic')} href={RouteUrl.MATCH_INTRODUCE} target="_blank">
            <span className={cx('title')}>기업에게 입사제안 받는 방법 확인</span>
            <Icon name="arrowRightLight" width={24} height={24} fill={Colors.C_COOL_GRAY_50} />
          </Link>
        </div>
        <div className={cx('sliderItem', 'type2')} />
        <div className={cx('sliderItem', 'type3')} />
      </ImgSlide>

      <Link className={cx('btnLink', 'btnJoin')} href={RouteUrl.PROFILE} target="_blank">
        프로필 신규 작성 / 업데이트 하기
        <Icon name="guideLight" width={32} height={32} fill={Colors.C_JOBDA_BLACK} />
      </Link>

      <button className={cx('btnBasic')} onClick={() => openModal('PROFILE_SAMPLE')}>
        <span className={cx('title')}>프로필 Sample 확인하기</span>
        <div className={cx('btnIcon')}>
          <Icon name="arrowRightLight" width={24} height={24} fill={Colors.C_COOL_GRAY_50} />
        </div>
      </button>
    </div>
  );
};

export default Step;
